import { useParams, useHistory } from "react-router-dom";
import EditorDiv from "./EditorDiv";
import PreviewSlide from "./PreviewSlide";
import "./editor.css";
import { useEffect, useState } from "react";
import useHttp from "../../hooks/use-http";
import { endPoints } from "../../config/end-points";
import { useSelector, useDispatch } from "react-redux";
import { campaignAction } from "../../store/campaign-store";
import { authActions } from "../../store/auth";
import ImageEditor from "./ImageEditor";
import { saveLocalData } from "../../helpers/storage-helper";

const CampaignEditor = () => {
  const { camp_id } = useParams();

  const { sendRequest: campTempRequest } = useHttp();
  const token = useSelector((state) => state.auth.token);
  const editor_page_load = useSelector(
    (state) => state.campaign.editor_page_load
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const video_data = useSelector((state) => state.campaign.video_data);
  const active_slide_duration = useSelector(
    (state) => state.campaign.active_slide_duration
  );
  const total_duration = useSelector((state) => state.campaign.total_duration);
  const imageData = useSelector((state) => state.campaign.image_editor);

  const [tempdata, setTempdata] = useState("");

  useEffect(() => {
    const responseHandle = (response) => {
      console.log("Calling rest APi campTemp");

      if (response.body) {
        // console.log("Hello JSON");
        // console.log(response.body.script_data);
        // console.log(JSON.parse(response.body.campaign_data));

        var sdata = response.body.script_data;
        saveLocalData("script_data", sdata );
        sdata = JSON.parse(sdata);
        console.log(typeof sdata);
        if( typeof sdata === "object" ){
          setTempdata(sdata);
        }

        dispatch(campaignAction.resetState());

        dispatch(
          campaignAction.preState({
            camp_id: camp_id,
          })
        );

        dispatch(campaignAction.setEditorpageLoad({ editor_page_load: true }));
        const campaign = response.body;

        if (campaign.process_flow >= 2) {
          history.push("/render/" + camp_id);
          return false;
        }

        const campaign_slide_data = JSON.parse(campaign.campaign_data);

        if (campaign_slide_data) {
          console.log("Calling Inside");
          dispatch(
            campaignAction.setVideoData({
              video_data: campaign_slide_data,
            })
          );
        }
      }
      dispatch(authActions.setLoaderStatus({ status: false, loader_text: "" }));
    };

    if (!editor_page_load) {
      dispatch(authActions.setLoaderStatus({ status: true }));

      campTempRequest(
        {
          url: endPoints.fetchCampaign + "/" + camp_id,
          method: "GET",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
        responseHandle
      );
    }else{
      var sdata = localStorage.getItem("script_data");
      if(sdata){
        
        var tpe = typeof sdata; 
        if( tpe === "string" ){
          sdata = JSON.parse(sdata)
        }
        tpe = typeof sdata; 
        if( tpe === "string" ){
          sdata = JSON.parse(sdata)
        }
        tpe = typeof sdata; 
        console.log(tpe);
        if( tpe === "object" ){
          setTempdata(sdata);
        }
        
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campTempRequest, camp_id, token]);

  const Format = ({ time }) => {
    // Hours, minutes and seconds
    // console.log(time);
    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = ~~time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";
    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
    ret += "" + (mins < 1 ? "00" : mins) + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret + " min";
  };

  return (
    <>
      <div className="row">
        <div className="card">
          <div className="card-body p-3-9">
            <span className="fsgtLt pull-right">
              <i className="fa fa-clock"></i> Video Duration{" "}
              <Format time={parseInt(total_duration)} />
            </span>
            <span className="jKZKqA pull-right">
              <i className="fa fa-clock"></i> Scene Duration :{" "}
              <span className="text-primary">{active_slide_duration} sec</span>
            </span>

            <span className="jKZKqA pull-right">
              <i className="fa fa-picture-o"></i> Total Scenes :{" "}
              {video_data.length}
            </span>
          </div>
        </div>
      </div>
      <section className="mid_wrap p-9">
        <div className="container">
          <div className="row align-items-center mb-5">
            <EditorDiv
            tempdata= {tempdata}
            />
          </div>
        </div>
        <PreviewSlide />

        {imageData && <ImageEditor />}
      </section>
    </>
  );
};

export default CampaignEditor;
